// @flow

type ActionType = {
  type: string,
  value: any
}

type initialStateType = {}

export const reduce = (initialState: any, actionMap: any) =>
  (state: initialStateType = initialState, action: ActionType) => {
    if (actionMap[action.type]) {
      return {
        ...state,
        [actionMap[action.type]]: action.value,
      };
    }
    return {
      ...state,
    };
  };
export const store = (action: string, value: any) =>
  (dispatch: () => void) => {
    dispatch({
      type: action,
      value,
    });
  };
